export enum PracticeRegion {
    NI = 'Northern Ireland',
    ROI = 'Republic of Ireland'
}

export interface IPractice {
    id?: number;
    name: string;
    privateKey?: string;
    urlBase?: string;
    logo?: string;
    brandingColor?: string;
    townCity?: string;
    yearSlotLimit?: boolean;
    phoneNumber?: string;
    textService?: boolean;
    region: PracticeRegion;
    paymentService?: boolean;
    stripePublishableKey?: string;
    stripeSecretKey?: string;
    addMedicalCardNumber?: boolean;
    addPPSNumber?: boolean;
    addHealthcareNumber?: boolean;
    depositService?: boolean;
    addCustomerEmail?: boolean;
    emailRequired?: boolean;
    redirectOnBooking?: boolean;
    redirectOnBookingURL?: string;
    filterByPracticioner?: boolean;
}
